export default __webpack_public_path__ + "media/images/gps-676323cbea3e470b76a19e5074e28382.svg";